import { createStyles, Theme } from '@material-ui/core/styles';

import { colours } from '@shared/theme/colours';

export const styles = ({ spacing }: Theme) =>
  createStyles({
    root: {
      alignItems: 'flex-start',
      background: colours.solid.white,
      borderBottom: `1px solid ${colours.neutral[200]}`,
      display: 'flex',
      gap: 8,
      padding: 16,
      width: '100%',
    },
    main: {
      display: 'flex',
      flex: 1,
      flexDirection: 'column',
      gap: 2,
      minWidth: 0,
    },
    headerRow: {
      alignItems: 'flex-start',
      display: 'flex',
      gap: 8,
      justifyContent: 'space-between',
    },
    title: {
      color: colours.neutral[900],
      display: '-webkit-box',
      fontSize: 14,
      fontWeight: 600,
      lineHeight: '20px',
      overflow: 'hidden',
      WebkitBoxOrient: 'vertical',
      WebkitLineClamp: 2,
      wordBreak: 'break-word',
    },
    time: {
      color: colours.neutral[400],
      flexShrink: 0,
      fontSize: 12,
      fontWeight: 400,
      lineHeight: '18px',
    },
    message: {
      color: colours.neutral[600],
      fontSize: 14,
      fontWeight: 400,
      lineHeight: '20px',
      wordBreak: 'break-word',
    },
    subtext: {
      color: colours.neutral[500],
      fontSize: 13,
      fontWeight: 400,
      lineHeight: '18px',
      wordBreak: 'break-word',
    },
    badgeRow: {
      display: 'flex',
      marginTop: spacing(1),
    },
  });
